const AGE18_CONFIRMATION_COOKIE = 'age18_confirmed'
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365

export function useAgeConfirmation() {
  const cookie = useCookie<boolean | null>(AGE18_CONFIRMATION_COOKIE, {
    default: () => null,
    maxAge: ONE_YEAR_IN_SECONDS,
    path: '/',
    sameSite: 'lax',
  })
  const decision = useState<boolean | null>('age18-confirmation-decision', () => cookie.value ?? null)

  const confirm = () => {
    decision.value = true
    cookie.value = true
  }

  return {
    decision,
    confirm,
  }
}
